import gql from 'graphql-tag';
import { TypedDocumentNode } from '@apollo/client';
import { DefaultApiResponse, DefaultArg } from '@libs/graphql';
import { TransactionAmountType } from '@libs/backend-common';
import { CurrencyType } from 'src/constants';
type ExchangeFee = {
  buyRate?: number;
  sellRate?: number;
};

type FeeConditions = {
  exchangeFee?: ExchangeFee;
};

// Exchange Pre-Request
export type RequestExchangeNewEntity = {
  id: string | number;
  originalAmount: number;
  rate: number;
  expiresIn: number;
  receivedAmount: number;
  neededAmount: number;
  feeAmount: number;
  feeConditions?: FeeConditions;
};
export type RequestExchangeNewResponse = {
  requestExchangeNew: DefaultApiResponse<RequestExchangeNewEntity>;
};
export type RequestExchangeNewArgs = {
  amount: number;
  type: TransactionAmountType;
  fromAssetCode: CurrencyType;
  toAssetCode: CurrencyType;
};

export const requestExchangeNewMutation: TypedDocumentNode<
  RequestExchangeNewResponse,
  DefaultArg<RequestExchangeNewArgs>
> = gql`
  mutation RequestExchangeNew($record: CalculateExchangeRecord!) {
    requestExchangeNew(record: $record) {
      id
      originalAmount
      rate
      expiresIn
      receivedAmount
      neededAmount
      feeAmount
      feeConditions
    }
  }
`;
